<template>
  <div class="card-inner-group">
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>
